<template>
    <div style="font-size: 15px; padding: 10px">
        <div style="font-weight: bold">
            <slot name="title"></slot>
        </div>
        <div>
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TextCard"
    }
</script>

<style scoped>

</style>